import { Button } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import {
  SelectManual,
  type SelectManualProps,
} from "@src/components/ui-kit/Select/manual";
import type { SelectRef } from "@src/components/ui-kit/Select/Select";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRef } from "react";

type TagSelectProps = Omit<SelectManualProps, "isMulti">;
export const TagSelect = observer<TagSelectProps>(function TagSelect(props) {
  const { tagModalStore } = useStore();
  const ref = useRef<SelectRef>(null);

  return (
    <SelectManual
      ref={ref}
      isMulti
      asPortal
      placeholder={t`Select tag`}
      {...props}
      topExtraContent={
        <Button
          px="2"
          py="2"
          onClick={() => {
            tagModalStore.modalState.onOpen();
            ref.current?.onMenuClose();
          }}
          size="sm"
          variant="link"
        >
          <Trans>Edit tags</Trans>
        </Button>
      }
    />
  );
});
